export const loc = (obj, field, language) =>
  (language === "en" && obj?.[`${field}_en`]) ? obj[`${field}_en`] : obj?.[field];
